var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { display: "inline-block" } }, [
    _vm.entry.Reversed
      ? _c("div", { staticClass: "status reversed" }, [
          _vm._v("\n        REVERSED\n    ")
        ])
      : _vm.entry.BillingWorksheetId === null
      ? _c("div", { staticClass: "status not-invoiced" }, [
          _vm._v("\n        NOT INVOICED\n        "),
          _vm.nonBillable
            ? _c("span", [_c("br"), _vm._v("NOT BILLABLE")])
            : _vm._e()
        ])
      : _vm.entry.BilledDate === null && _vm.entry.ParentWorksheetId === null
      ? _c("div", { staticClass: "status bw-active" }, [
          _vm._v("\n        WORKSHEET CREATED\n        "),
          _vm.nonBillable
            ? _c("span", [_c("br"), _vm._v("NOT BILLABLE")])
            : _vm._e()
        ])
      : _c("div", { staticClass: "status invoiced" }, [
          _vm._v("\n        INVOICED\n        "),
          _vm.nonBillable
            ? _c("span", [_c("br"), _vm._v("NOT BILLABLE")])
            : _vm._e()
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c954848", { render: render, staticRenderFns: staticRenderFns })
  }
}